import { EVALUATION } from '@/constant';
import { useSubscription } from '@/providers/subscription/SubscriptionProvider';
import { Alert, AlertTitle, Snackbar } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

type EvaluationPath = '/students';

const EVALUATION_PATHS: EvaluationPath[] = ['/students'];

function isEvaluationPage(pathname: string): pathname is EvaluationPath {
    return EVALUATION_PATHS.some((path) => pathname.startsWith(path));
}

export const EvaluationHandler = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const { subscribed } = useSubscription();
    const [show, setShow] = useState<boolean>(false);
    const descriptions: Record<EvaluationPath, string> = {
        '/students': t('trial.description.student', { count: EVALUATION.MAX_STUDENTS }),
    };

    const handleClose = () => {
        setShow(false);
    };

    useEffect(() => {
        if (subscribed === true || !isEvaluationPage(location.pathname)) {
            setShow(false);
        } else if (subscribed === false && isEvaluationPage(location.pathname)) {
            setShow(true);
        }
    }, [subscribed, location]);

    return (
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={show}>
            <Alert severity='info' color='info' onClose={handleClose} variant='filled'>
                <AlertTitle>{t('trial.title')}</AlertTitle>
                {isEvaluationPage(location.pathname) && descriptions[location.pathname]}
            </Alert>
        </Snackbar>
    );
};
